// extracted by mini-css-extract-plugin
module.exports = {"designer-without-stripe-block":"styles_designer-without-stripe-block__2HFKl","add-stripe-account-button":"styles_add-stripe-account-button__2-sB_"};